import  { HANDLE_CUSTOMER_JOBCARD, RESET } from "../actions";

const initialState = {
    customerName: "",
    phone: "",
    customerJobCardApiCalled: false,
    jobCard: [],
    status: [4],

    productSearch: "",
    assigned: "",
    device_type: ""
};

const customers = (state = initialState, action) => {
    switch(action.type) {
        case HANDLE_CUSTOMER_JOBCARD : 
            return {
                ...state,
                ...action.data
            }
        case RESET :
            return initialState
        default:
            return state;
    }
}

export default customers;